'use client'
import * as Dialog from 'primitives/dialog'
import * as React from 'react'
import { useJoinClubhouseModal } from './join-clubhouse-modal-provider'
import { JoinClubhouseModal } from './index'

export function JoinClubhouseModalWrapper() {
  const { closeModal, isOpen, slug } = useJoinClubhouseModal()

  if (!slug) {
    return null
  }

  return (
    <Dialog.Root defaultOpen open={isOpen} onOpenChange={open => !open && closeModal()}>
      <React.Suspense fallback={null}>
        <Dialog.Portal>
          <Dialog.Body
            dismissable={false}
            className="font-poppins z-50 xl:overflow-y-auto xl:py-10"
          >
            <JoinClubhouseModal slug={slug} onClose={closeModal} />
          </Dialog.Body>
        </Dialog.Portal>
      </React.Suspense>
    </Dialog.Root>
  )
}
